import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74257266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-text" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-book fa-padding",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = {
  href: "https://samr1.github.io/FitTrackee/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-github fa-padding",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = {
  href: "https://github.com/SamR1/FitTrackee",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-balance-scale fa-padding",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://choosealicense.com/licenses/agpl-3.0/",
  target: "_blank",
  rel: "noopener noreferrer"
}, " AGPLv3 ", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-envelope-o fa-padding",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = ["href"]

import { ComputedRef, computed, capitalize } from 'vue'

  import { ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()
  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", {
        class: "error-message",
        innerHTML: _ctx.$t('about.FITTRACKEE_DESCRIPTION')
      }, null, 8, _hoisted_2),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("a", _hoisted_4, _toDisplayString(capitalize(_ctx.$t('common.DOCUMENTATION'))), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_5,
        _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('about.SOURCE_CODE')), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createVNode(_component_i18n_t, { keypath: "about.FITTRACKEE_LICENSE" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      (_unref(appConfig).admin_contact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("a", {
              href: `mailto:${_unref(appConfig).admin_contact}`
            }, _toDisplayString(_ctx.$t('about.CONTACT_ADMIN')), 9, _hoisted_11)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})